import { render, staticRenderFns } from "./sub_alfx_detail_yl.vue?vue&type=template&id=b26acbb8&scoped=true"
import script from "./sub_alfx_detail_yl.vue?vue&type=script&lang=js"
export * from "./sub_alfx_detail_yl.vue?vue&type=script&lang=js"
import style0 from "./sub_alfx_detail_yl.vue?vue&type=style&index=0&id=b26acbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26acbb8",
  null
  
)

export default component.exports